export default __webpack_public_path__ + "static/2_18-064cab07bab46cb525fe86d40d7d806d.png";